export default __webpack_public_path__ + "static/media/error-icon.f92a54ae.svg";